<template>
  <ul>
    <li v-for="(savedScenario, i) in savedScenarios[tool]">
      <a v-bind:href="savedScenario.url">{{ savedScenario.title }}</a>
      <span
        class="glyphicon glyphicon-edit"
        v-on:click="expandEditNameModal(i)"
      ></span>
      <span
        v-if="i > 0"
        class="glyphicon glyphicon-chevron-up"
        v-on:click="moveScenarioUp(i)"
      ></span>
      <span
        v-if="i < savedScenarios[tool].length - 1"
        class="glyphicon glyphicon-chevron-down"
        v-on:click="moveScenarioDown(i)"
      ></span>
      <span
        class="close" v-on:click="deleteScenario(tool, i)"
      >
        &times;
      </span>
    </li>
    <ppt-modal class="edit-name-modal">
      <header slot="header">
        <strong>Update name</strong>
        <button class="close" data-dismiss="modal"><span>&times;</span></button>
      </header>
      <section slot="body">
        <p>Old name: {{ savedScenarios[tool][indexForEditNameModal].title }}</p>
        <p>
          New name: <input type="text" v-model="newName">
        </p>
      </section>
      <section slot="footer">
        <section class="modal-footer">
          <button class="btn btn-default" v-on:click="collapseEditNameModal()">
            Cancel
          </button>
          <button class="btn btn-primary" v-on:click="updateName()">
            Update
          </button>
        </section>
      </section>
    </ppt-modal>
  </ul>
</template>

<script>
import PPTModal from '@/components/utilities/modal';

export default {
  name: 'saved-scenarios-for-tool',
  props: ['savedScenarios', 'tool'],
  components: {
    'ppt-modal': PPTModal,
  },
  data: function () {
    return {
      indexForEditNameModal: 0,
      newName: '',
    };
  },
  methods: {
    expandEditNameModal: function (index) {
      this.indexForEditNameModal = index;
      this.newName = this.savedScenarios[this.tool][index].title;
      $(this.$el).find('.edit-name-modal').modal();
    },
    collapseEditNameModal: function () {
      $(this.$el).find('.edit-name-modal').modal('hide');
    },
    updateName: function () {
      let self = this;
      let user = _.cloneDeep(self.$store.state.account.user);
      let newSavedScenarios = _.cloneDeep(self.$store.state.account.user.savedScenarios);

      newSavedScenarios[self.tool][self.indexForEditNameModal].title = self.newName;
      user.savedScenarios = newSavedScenarios;

      self.$http
        .put(`${process.env.BASE_API_URL}/user`, {
          user: user,
        })
        .then(function (res) {
          self.newName = '';
          self.$store.commit('account/setUser', res.data.user);
          self.collapseEditNameModal();
        })
        .catch(function (err) {
          alert('Problem trying to move the scenario.');
        })
      ;
    },
    deleteScenario: function (index) {
      let self = this;
      let user = _.cloneDeep(self.$store.state.account.user);
      let newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.tool].splice(index, 1);
      user.savedScenarios = newSavedScenarios;

      self.$http
        .put(`${process.env.BASE_API_URL}/user`, {
          user: user,
        })
        .then(function (res) {
          self.$store.commit('account/setUser', res.data.user);
          alert('Successfully removed the scenario.');
        })
        .catch(function (err) {
          alert('Problem trying to remove the scenario.');
        })
      ;
    },
    moveScenarioUp: function (index) {
      let self = this;
      let user = _.cloneDeep(self.$store.state.account.user);
      let newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.tool].move(index, index - 1);
      user.savedScenarios = newSavedScenarios;

      self.$http
        .put(`${process.env.BASE_API_URL}/user`, {
          user: user,
        })
        .then(function (res) {
          self.$store.commit('account/setUser', res.data.user);
        })
        .catch(function (err) {
          alert('Problem trying to move the scenario.');
        })
      ;
    },
    moveScenarioDown: function (index) {
      let self = this;
      let user = _.cloneDeep(self.$store.state.account.user);
      let newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.tool].move(index, index + 1);
      user.savedScenarios = newSavedScenarios;

      self.$http
        .put(`${process.env.BASE_API_URL}/user`, {
          user: user,
        })
        .then(function (res) {
          self.$store.commit('account/setUser', res.data.user);
        })
        .catch(function (err) {
          alert('Problem trying to move the scenario.');
        })
      ;
    },
  },
};
</script>

<style lang="scss" scoped>
  .close {
    float: none;
  }

  .glyphicon {
    color: lightgray;
    font-size: 12px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/saved-scenarios-for-tool.vue